import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { JobbingUpsertFormComponent } from "./jobbing-upsert-form/jobbing-upsert-form.component";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-jobbing-upsert',
  standalone: true,
  imports: [ReactiveFormsModule, JobbingUpsertFormComponent],
  templateUrl: './jobbing-upsert.component.html',
  styleUrl: './jobbing-upsert.component.scss'
})
export class JobbingUpsertComponent implements OnInit {

  formGroup!: FormGroup;
  jobId: number | null = null;

  constructor(private fb: FormBuilder, private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      if (params['id']) {
        this.jobId = params['id'];
      }
    });

    this.formGroup = this.fb.group({
    });
  }

  returnToDeliveryStatusView() {
    this.router.navigate(['app/jobbing/home']);
  }
}
